import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Empresa } from '../api/dto/empresa';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { EmpresaRequest } from '../api/dto/empresa-request';
import { PageResponse } from '../api/dto/paginacao/page-response';

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {
  constructor(private http: HttpClient) { }
  private url: string = UrlServidor.URL_BASE + 'empresas';

  getEmpresas(id: number): Observable<Empresa[]> {
    return this.http.get<Empresa[]>(this.url + '/usuario/' + id);
  }

  listarPorUsuarioId(id?: number): Observable<Empresa[]> {
    return this.http.get<Empresa[]>(this.url + '/usuario/' + id);
  }

  listarEmpresas(): Observable<Empresa[]> {
    return this.http.get<Empresa[]>(this.url);
  }

  listarEmpresasPorFranquia(administradoraId?: number): Observable<Empresa[]> {


    return this.http.get<Empresa[]>(`${this.url}/administradora/${administradoraId}`);
  }

  listarEmpresasPorFranquiaPaginado(administradoraId?: number, pagina?: number,
     tamanho?: number, ordenacao?: string, inputBusca?: string): Observable<PageResponse<Empresa>> {

    let parametros = new HttpParams();
    if (inputBusca) {
        parametros = parametros.set('busca', inputBusca);
    }
    if (pagina) {
      parametros = parametros.set('page', pagina)
    }
    if (tamanho) {
      parametros = parametros.set('size', tamanho)
    }
    if (ordenacao) {
        parametros = parametros.set('sort', ordenacao);
    }
    
    console.log(parametros)

    return this.http.get<PageResponse<Empresa>>(
      `${this.url}/administradora/${administradoraId}/paginado`, { params: parametros });
  }

  buscarPorId(id?: number): Observable<Empresa> {
    return this.http.get<Empresa>(this.url + "/" + id);
  }

  buscarDadosEmpresa(id?: number): Observable<EmpresaRequest> {
    return this.http.get<EmpresaRequest>(`${this.url}/${id}/dados-empresa`);
  }

  salvar(empresa?: Empresa): Observable<Empresa> {
    return this.http.post<Empresa>(this.url, empresa);
  }

  atualizarDados(empresaRequest?: EmpresaRequest): Observable<void> {
    return this.http.put<void>(`${this.url}/dados-empresa`, empresaRequest);
  }

  atualizar(empresa?: Empresa, id?: number): Observable<Empresa> {
    return this.http.put<Empresa>(this.url + '/' + id, empresa);
  }

  listarPorCnpjCpf(cnpjCpf?: string): Observable<Empresa> {
    return this.http.get<Empresa>(this.url + '/cnpj-cpf/' + cnpjCpf);
  }

  salvarLogo(id: number, logo: Blob): Observable<void> {
    const arquivo = new FormData();
    arquivo.append('logo', logo, 'logo.png');
    return this.http.post<void>(UrlServidor.URL_BASE + `empresa-logo/empresa/${id}`, arquivo);
  }

  buscarLogo(id: number): Observable<Blob> {
    console.log('buscou logo')
    return this.http.get(`${UrlServidor.URL_BASE}empresa-logo/empresa/${id}`, { responseType: 'blob' });
  }
}